import React from "react";
import "../assets/scss/layoutweb.scss";
import { Link } from "react-router-dom";
import { customersDtls } from "../locales/en";
import { DASHBOARD } from "../route/paths";

export default function Forbidden() {
  return (
    <section className="container-fluid error-page text-center">
      <div className="container">
        <h2>
          {customersDtls?.notFound.item1}
          <span>{customersDtls?.notFound.item2}</span>
          {customersDtls?.notFound.item4}
        </h2>
        <p>{customersDtls?.notFound.forbidden}</p>
        <div className="d-flex justify-content-center">
          <Link to={DASHBOARD} className="btn btn-primary">
            {customersDtls?.notFound.goToDashboardBtn}
          </Link>
        </div>
      </div>
    </section>
  );
}
